import { deleteRequest, getRequest } from '../../../services/base'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { useParams } from 'react-router-dom'
import CreateUpdateConnector from './form'
import { ConnectorContext } from './context/context'
import ConnectorListRow from './ConnectorRow'

const ConnectorList = (props) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [connectorState, connectorDispatch] = useContext(ConnectorContext)
  const [connectorListData, setConnectorListData] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const [selectedConnector, setSelectedConnector] = useState({})

  useEffect(() => {
    getConnectorList(null)
  }, [])

  const getConnectorList = async (url = null) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Connector`s Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(
      url ? url : `/api/connector/?vehicle=${vehicle}&search=${searchValue}`
    )
    connectorDispatch({ type: 'set_connector_data', data: response.results })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deleteConnector = async (connector) => {
    if (
      window.confirm(`Are you sure want to delete ${connector.name}`) === true
    ) {
      console.log(connector)
      let res = await deleteRequest(
        `/api/connector/delete/${vehicle}/${connector.name}/`
      )
      console.log(res, 'resres')
      getConnectorList('')
    }
  }

  return (
    <>
      <CreateUpdateConnector
        showModal={showModal}
        setShowModal={setShowModal}
        getConnectorList={getConnectorList}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          getConnectorList(null)
        }}
      >
        <div className="flex space-x-5">
          <div className="w-1/4">
            <input
              autoComplete="off"
              className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none text-black"
              placeholder="Enter to search"
              type="search"
              name="search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value)
              }}
            />
          </div>
          <button className="bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded">
            Search
          </button>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-4/12 pl-10 items-center">Name</div>
          <div className="flex w-2/12 pl-6 items-center">Category</div>
          <div className="flex w-4/12 pl-6 items-center">Description</div>
          <div className="w-2/12 pl-6">Cavities</div>
          <div className="w-2/12 pl-6">Icon</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {connectorState?.data?.map((connector, index) => {
        return (
          <ConnectorListRow
            {...connector}
            key={`connector-${index}`}
            onEdit={() => {
              connectorDispatch({
                type: 'set_selected_connector',
                data: { ...connector, index: index },
              })

              setShowModal(true)
            }}
            onDelete={() => deleteConnector(connector)}
          />
        )
      })}
      {connectorState?.data?.length < 1 && (
        <NoRecordsFound caption={"User's Not Found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getConnectorList(e)
          }}
          onClickPrev={(e) => {
            getConnectorList(e)
          }}
        />
      </div>
    </>
  )
}

export default ConnectorList
